import FlexTableRow from './flex_table_row';

export default FlexTableRow;
